import { render, staticRenderFns } from "./DashboardHome.vue?vue&type=template&id=5dec7690&"
import script from "./DashboardHome.vue?vue&type=script&lang=js&"
export * from "./DashboardHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports